import styled from 'styled-components'

export const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`
